module.exports = __webpack_public_path__ + "pn.981d8f79535572078825.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/pn.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/pn.svg
// module chunks = styles